"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Visibility_1 = __importDefault(require("@material-ui/icons/Visibility"));
const VisibilityOff_1 = __importDefault(require("@material-ui/icons/VisibilityOff"));
const classnames_1 = __importDefault(require("classnames"));
const react_1 = require("react");
const react_number_format_1 = require("react-number-format");
const components_1 = require("components");
const InputNumber = ({ input, meta, ...rest }) => {
    const { label = '', placeholder = '', required, requiredIndicator = ' *', labelnote = null, hinttype = null, isAllowed = undefined, hiddenicon = 'false', preicon = false, allowLeadingZeros = true, datatestid = '', altclass = null, fieldclass = '', } = rest;
    const [typePassword, setTypePassword] = (0, react_1.useState)(hiddenicon);
    const [iconOpen, setIconOpen] = (0, react_1.useState)(false);
    const handleClickIcon = () => {
        setIconOpen(!iconOpen);
    };
    const inputType = (0, react_1.useMemo)(() => {
        if (typePassword === 'true') {
            return 'password';
        }
        else {
            return 'tel';
        }
    }, [typePassword]);
    (0, react_1.useEffect)(() => {
        if (iconOpen) {
            setTypePassword('false');
        }
        else {
            setTypePassword('true');
        }
    }, [iconOpen]);
    (0, react_1.useEffect)(() => {
        setTypePassword(hiddenicon);
    }, [hiddenicon]);
    const fieldClass = input && meta
        ? (0, classnames_1.default)({
            [fieldclass]: fieldclass ?? false,
            'error-fieldset': (meta.error && meta.touched) ||
                (meta.error && meta.pristine === false),
            'pre-icon': rest.preicon,
        })
        : '';
    const labelClass = (0, classnames_1.default)({
        'form-label': altclass === 'coreUI',
    });
    const inputClass = (0, classnames_1.default)({
        'form-control': altclass === 'coreUI',
    });
    const inputName = input ? input.name : datatestid;
    return ((0, jsx_runtime_1.jsxs)("fieldset", { "data-testid": `fieldset-${inputName}`, className: fieldClass, children: [(0, jsx_runtime_1.jsxs)("span", { className: "whitespace-nowrap", children: [(0, jsx_runtime_1.jsxs)(components_1.Label, { size: "medium", "data-testid": `label-${inputName}`, htmlFor: inputName, className: `${altclass ? labelClass : ''}`, children: [label, required && ((0, jsx_runtime_1.jsx)("span", { className: "required-indicator", "aria-hidden": "true", children: requiredIndicator })), rest.tooltip ? (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: rest.tooltip }) : null] }), labelnote && labelnote] }), (0, jsx_runtime_1.jsx)("div", { className: "input-wrapper", children: (0, jsx_runtime_1.jsxs)("div", { className: "flex-center", children: [preicon ? (0, jsx_runtime_1.jsx)("div", { className: "pre-icon-container", children: preicon }) : null, (0, jsx_runtime_1.jsx)(react_number_format_1.NumericFormat, { ...input, ...rest, className: `${altclass ? inputClass : ''}`, name: inputName, allowLeadingZeros: allowLeadingZeros, "data-testid": `input-${inputName}`, placeholder: placeholder, isAllowed: isAllowed, type: inputType }), (0, jsx_runtime_1.jsx)("div", { className: "input-hidden-icon", children: hiddenicon === 'true' ? ((0, jsx_runtime_1.jsx)("button", { type: "button", onClick: handleClickIcon, children: iconOpen ? (0, jsx_runtime_1.jsx)(Visibility_1.default, {}) : (0, jsx_runtime_1.jsx)(VisibilityOff_1.default, {}) })) : null })] }) }), meta &&
                (meta.error || meta.submitError) &&
                (meta.touched || meta.modified) && ((0, jsx_runtime_1.jsx)("span", { className: "error-message", children: meta.error || meta.submitError })), meta && (meta.active || meta.modified || meta.touched) && hinttype
                ? hinttype
                : null] }));
};
exports.default = InputNumber;
